import React from "react";

import {
  Button,
  Grid,
  Typography,
  colors,
  makeStyles,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";

import { Logo } from "@hubcapp/components";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    paddingTop: "10vh",
    display: "flex",
    flexDirection: "column",
    alignContent: "center",
    background: "#F2F2F2",
    height: "100vh",
  },
  textContainer: {
    marginTop: theme.spacing(7),
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  buttonContainer: {
    marginTop: theme.spacing(7),
    display: "flex",
    justifyContent: "center",
  },
  logoContainer: {
    marginBottom: theme.spacing(7),
    display: "flex",
    justifyContent: "center",
  },
  text: {
    fontSize: "1rem",
    lineHeight: "1.5rem",
    fontWeight: 400,
    color: colors.blueGrey[500],
    maxWidth: "30rem",
    width: "100%",
  },
}));

const Error408 = () => {
  const classes = useStyles();
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div className={classes.root} title="Error 401">
      <Grid container justify="center" className={classes.logoContainer}>
        <Logo />
      </Grid>

      <Typography align="center" variant={mobileDevice ? "h4" : "h1"}>
        We&apos;ve hit a problem
      </Typography>
      <Grid className={classes.textContainer}>
        <Typography variant="body1" className={classes.text}>
          We have a problem getting your details.
        </Typography>
        <Typography variant="body1" className={classes.text}>
          Check your connection to the internet or try again in a moment.
        </Typography>
      </Grid>
      <Grid className={classes.buttonContainer}>
        <Button
          color="primary"
          component={RouterLink}
          to="/"
          variant="contained"
        >
          Refresh page
        </Button>
      </Grid>
    </div>
  );
};

export default Error408;
